import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { NbButton } from "../components/nb";
import { useAuth } from "../context/AuthContext";
import { Check, Crown, CreditCard, Truck, Sparkles } from "lucide-react";

export default function Pricing() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const premiumFeatures = [
    "Personal QR VIP code (download & print)",
    "Custom badge themes & event names",
    "Unlimited browsing & keyword search",
    "Likes, favorites & mutual matches",
    "Unlimited direct messaging + read receipts",
    "See who likes you",
    "Advanced premium filters",
    "Verified badge & priority in search",
  ];
  const cardFeatures = [
    "100 premium matte business-style cards",
    "Your personal QR code + name printed",
    "Designed in your chosen badge theme",
    "Perfect for events, bars & networking",
    "Ships straight to your door",
    "One-time purchase — no subscription",
  ];

  return (
    <div className="min-h-screen bg-[#FCFCFA]">
      <Navbar />
      <section className="max-w-5xl mx-auto px-6 sm:px-8 py-16">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-stone-500 mb-3">Membership & merch</div>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight text-stone-900">One simple price. Real connections.</h1>
          <p className="text-stone-600 mt-5 leading-relaxed">Everything qrcupid offers from just <span className="font-medium text-stone-900">$8.50 / month</span> — or <span className="font-medium text-stone-900">$40 for 6 months</span>. Want to hand out your QR in person? Add a pack of printed cards.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7 items-stretch">
          {/* Premium membership */}
          <div data-testid="plan-premium" className="relative bg-white rounded-3xl border border-stone-100 shadow-[0_16px_50px_rgb(28,25,23,0.08)] p-8 flex flex-col">
            <span className="absolute -top-3 left-8 bg-[#8B1E3F] text-white text-xs font-medium px-3 py-1 rounded-full flex items-center gap-1"><Sparkles className="w-3 h-3" /> Everything included</span>
            <div className="flex items-center gap-2 font-display text-2xl font-medium text-stone-900"><Crown className="w-6 h-6 text-[#D4AF37]" /> Premium</div>
            <div className="mt-4 flex items-end gap-1">
              <span className="font-display text-5xl font-medium text-stone-900">$8.50</span>
              <span className="text-stone-500 mb-1.5">/ month</span>
            </div>
            <p className="text-sm text-stone-500 mt-1">Cancel anytime · or $40 for 6 months (save ~22%).</p>
            <ul className="mt-6 space-y-3 flex-1">
              {premiumFeatures.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm text-stone-700">
                  <span className="mt-0.5 w-4 h-4 rounded-full bg-[#F3E8E6] flex items-center justify-center flex-shrink-0"><Check className="w-3 h-3 text-[#8B1E3F]" strokeWidth={3} /></span>
                  {f}
                </li>
              ))}
            </ul>
            <NbButton data-testid="plan-cta-premium" className="w-full mt-8" onClick={() => navigate(user ? "/upgrade" : "/register")}>
              <CreditCard className="w-4 h-4" /> Go Premium — $8.50/mo
            </NbButton>
          </div>

          {/* Printed cards */}
          <div data-testid="plan-cards" className="relative bg-[#1C1917] text-white rounded-3xl shadow-[0_16px_50px_rgb(28,25,23,0.18)] p-8 flex flex-col overflow-hidden">
            <div className="absolute inset-0 opacity-60" style={{ background: "radial-gradient(120% 120% at 100% 0%, rgba(212,175,55,0.18) 0%, transparent 45%)" }} />
            <div className="relative flex flex-col flex-1">
              <span className="absolute -top-2 right-0 bg-[#D4AF37] text-[#1C1917] text-xs font-medium px-3 py-1 rounded-full">Best for events</span>
              <div className="flex items-center gap-2 font-display text-2xl font-medium"><Truck className="w-6 h-6 text-[#D4AF37]" /> Printed Cards</div>
              <div className="mt-4 flex items-end gap-2">
                <span className="font-display text-5xl font-medium">$15</span>
                <span className="text-white/60 mb-1.5">for 100 cards</span>
              </div>
              <p className="text-sm text-white/50 mt-1">One-time order · just 15¢ a card.</p>
              <ul className="mt-6 space-y-3 flex-1">
                {cardFeatures.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-white/85">
                    <span className="mt-0.5 w-4 h-4 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0"><Check className="w-3 h-3 text-[#D4AF37]" strokeWidth={3} /></span>
                    {f}
                  </li>
                ))}
              </ul>
              <NbButton data-testid="plan-cta-cards" variant="accent" className="w-full mt-8" onClick={() => navigate(user ? "/order-cards" : "/register")}>
                <Truck className="w-4 h-4" /> Order 100 Cards — $15
              </NbButton>
            </div>
          </div>
        </div>

        <p className="text-center text-sm text-stone-500 mt-10">Secure payments powered by Authorize.Net. You can always browse for free — upgrade whenever you're ready.</p>
      </section>
      <Footer />
    </div>
  );
}